/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-19 18:41:06
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\success\locales\zh-CN.ts
 */
export default {
  'page.success.txtsucess': '注册成功，请登录后及时认证并完善个人信息。',
  'page.activation.txterror': '注册失败',
  'page.success.login': '登录',
};
